
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink, context } from 'dumi/theme';
    import Previewer from 'dumi-theme-mobile/es/builtins/Previewer.js';
import Alert from 'dumi-theme-default/es/builtins/Alert';
import API from 'dumi-theme-default/es/builtins/API';
import Badge from 'dumi-theme-default/es/builtins/Badge';
import Example from 'dumi-theme-default/es/builtins/Example';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode';
import Tree from 'dumi-theme-default/es/builtins/Tree';
import Table from 'dumi-theme-default/es/builtins/Table';

    // memo for page content, to avoid useless re-render since other context fields changed
    const PageContent = React.memo(({ demos: DUMI_ALL_DEMOS }) => {
      const DumiDemo1 = DUMI_ALL_DEMOS['timeline-demo'].component

      return (
        <>
          
          <React.Fragment><div className="markdown"><h1 id="timeline-时间线"><AnchorLink to="#timeline-时间线" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Timeline 时间线</h1>
<h2 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h2>
</div><Previewer {...DUMI_ALL_DEMOS['timeline-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h2 id="api"><AnchorLink to="#api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API</h2>
<h3 id="timeline-props"><AnchorLink to="#timeline-props" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Timeline props</h3>





























<Table><thead><tr><th>属性</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>className</td><td>自定义 Class 名</td><td>string</td><td>-</td></tr><tr><td>percent</td><td>百分比</td><td>string</td><td>-</td></tr><tr><td>color</td><td>颜色</td><td>string</td><td><code>#4666D8</code></td></tr></tbody></Table>
<h3 id="timelineitem-props"><AnchorLink to="#timelineitem-props" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>TimelineItem Props</h3>



























































<Table><thead><tr><th>属性</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>header</td><td>组件头部信息</td><td>ReactNode</td><td>-</td></tr><tr><td>footer</td><td>组件尾部信息</td><td>ReactNode</td><td>-</td></tr><tr><td>color</td><td>颜色</td><td>string</td><td>-</td></tr><tr><td>dashed</td><td>是否为虚线</td><td>boolean</td><td>false</td></tr><tr><td>count</td><td>Item 组件的数量</td><td>number</td><td>-</td></tr><tr><td>percent</td><td>百分比</td><td>string</td><td>-</td></tr><tr><td>showPercent</td><td>是否显示百分比</td><td>boolean</td><td>-</td></tr><tr><td>canShowColor</td><td>是否显示颜色</td><td>boolean</td><td>true</td></tr></tbody></Table></div></React.Fragment>
        </>
      );
    })

    export default (props) => {
      const { demos } = React.useContext(context);

      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return <PageContent demos={demos} />;
  }